module.exports = __webpack_public_path__ + "static/img/withdraw_appointment_rp.45190da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/withdraw_appointment_rp.png
// module id = Vaoi
// module chunks = 215